import axiosInstance from '../../../../services/axios/axios';
import { imageURL } from '../../../Data/baseURL';

const directUrl = (value) => typeof value === 'string' && /^(https?:\/\/|data:|blob:|\/)/i.test(value);

export const getPdfImageReference = (value) => {
  if (!value) return null;
  if (typeof value === 'object') {
    const id = value.unique_field || value.uf;
    if (id) return { id: String(id) };
    const url = value.s3_url || value.url || value.image || value.file;
    if (directUrl(url)) return { url };
    return value.id ? { id: String(value.id) } : null;
  }
  return directUrl(value) ? { url: value } : { id: String(value) };
};

export const rasterizePdfImage = (blob) => new Promise((resolve, reject) => {
  const url = URL.createObjectURL(blob);
  const image = new window.Image();
  const finish = (callback, value) => {
    URL.revokeObjectURL(url);
    callback(value);
  };
  image.onerror = () => finish(reject, new Error('The company image cannot be decoded.'));
  image.onload = () => {
    try {
      if (!image.naturalWidth || !image.naturalHeight) throw new Error('The company image is empty.');
      const scale = Math.min(1, 1600 / Math.max(image.naturalWidth, image.naturalHeight));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
      const context = canvas.getContext('2d');
      if (!context) throw new Error('Image conversion is unavailable.');
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      // PNG preserves transparency and supports uploaded SVGs in react-pdf.
      finish(resolve, canvas.toDataURL('image/png'));
    } catch (error) {
      finish(reject, error);
    }
  };
  image.src = url;
});

export const loadPdfImage = async (value, signal) => {
  const reference = getPdfImageReference(value);
  if (!reference) {
    if (value) throw new Error('The company image reference is invalid.');
    return null;
  }
  let blob;
  if (reference.id) {
    const response = await axiosInstance({
      url: imageURL,
      method: 'GET',
      params: { unique_field: reference.id, download: '1' },
      responseType: 'blob',
      timeout: 120000,
      signal,
    });
    blob = response.data;
  } else {
    const response = await fetch(reference.url, { signal, credentials: 'omit' });
    if (!response.ok) throw new Error('The company image could not be loaded.');
    blob = await response.blob();
  }
  if (signal?.aborted) throw new Error('PDF image loading was cancelled.');
  return rasterizePdfImage(blob);
};
